const sidebarEvents = () => {
  const eventTtile = document.querySelector(".sidebar-events-top");
  const container = document.querySelector(".sidebar");
  const containerMobile = document.querySelector(".events-banner");

  if (container != null) {
    if (
      document.querySelector(".sidebar-events div:nth-child(2)") === null &&
      document.querySelector(".sidebar .sidebar-events") != null
    ) {
      // eventTtile.style.display = "none";
    }
  }

  if (containerMobile != null) {
    if (
      document.querySelector(".featured-mobile div") === null &&
      document.querySelector(".events-banner:nth-child(3)") === null
    ) {
      // containerMobile.style.display = "none";
    }
  }
};

export default sidebarEvents;
